export const InscriptionType = {
	CPF: { id: 1, name: 'CPF', mask: '999.999.999-99' },
	CNPJ: { id: 2, name: 'CNPJ', mask: 'SS.SSS.SSS/SSSS-99' }
}



// WEBPACK FOOTER //
// ./src/enums/InscriptionType.js